import { Field } from 'formik'

const SelectField = ({ name, options = [], placeholder = 'Select an option', ...props }) => {
  return (
    <Field
      as="select"
      name={name}
      className="mt-2 block w-full rounded-lg border-gray-300 shadow-sm focus:border-brandSecondary focus:ring-brandSecondary"
      {...props}
    >
      <option value="">{placeholder}</option>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </Field>
  )
}

export default SelectField